import {Component, computed, inject, OnInit, signal} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BootstrapIcon, HeaderService} from "../../../services/header.service";
import {UserService} from "../../../services/user.service";
import {ReportDashboardService} from "../data-access/report-dashboard.service";
import {ReportCardComponent} from "../../../shared/components/report-card/report-card.component";
import {ReportTableComponent} from "../../dashboard/components/report-table/report-table.component";

@Component({
  selector: 'app-daily-dashboard',
  standalone: true,
  imports: [CommonModule, ReportCardComponent, ReportTableComponent],
  templateUrl: './daily-dashboard.component.html',
  styles: [`
    .daily-report-section {
      margin-bottom: 1rem;
    }
  `]
})
export class DailyReportDashboardComponent implements OnInit {
  private headerService = inject(HeaderService);
  protected userService = inject(UserService);
  protected reportDashboardService = inject(ReportDashboardService)
  displayedColumns: ["workplace", "category", "id", "reason"]

  endDate = signal<Date>(new Date());
  startDate = computed(() => {
    const date = new Date(this.endDate());
    date.setDate(date.getDate() - 1);
    return date;
  })

  dashboardItems = computed(() => {
    const vm = this.reportDashboardService.vmDaily();
    return [
      {
        heading: 'Gelöste Stillstände',
        name: 'solvedReports',
        dataSource: vm.solvedReports,
        tableHeading: "gelöste Stillstände: " + vm.solvedReports.length,
        tableHeadingClass: "text-qundis-primary qundis-ubuntu-32",
        displayedColumns: ["id", "workplace", "category", "reason"],
        columnWidths: 'equal'
      },
      {
        heading: 'Aktive Stillstände',
        name: 'activeReports',
        dataSource: vm.activeReports,
        tableHeading: "aktive Stillstände: " + vm.activeReports.length,
        tableHeadingClass: "text-qundis-warn qundis-ubuntu-32",
        displayedColumns: ["id", "time", "workplace", "category", "reason"],
        columnWidths: {"id": "20%", "time": "10%", "workplace": "25%", "category": "15%", "reason": "30%"}
      },
      {
        heading: "fortlaufende Stillstände",
        dataSource: vm.ongoingActiveReports,
        tableHeading: "fortlaufende aktive Stillstände: " +
          vm.ongoingActiveReports.length,
        tableHeadingClass: "text-qundis-warn qundis-ubuntu-32",
        displayedColumns: ["id", "time", "workplace", "category", "reason"],
        columnWidths: {"id": "20%", "time": "10%", "workplace": "25%", "category": "15%", "reason": "30%"}
      }
    ]
  })

  constructor() {
    this.headerService.setHeaderTitle('24h-Dashboard');
    this.headerService.setHeaderSubTitle(this.userService.userProductionLineName())
    this.headerService.setHeaderIcon(BootstrapIcon.dailyDashboard);
  }

  ngOnInit() {
    this.reportDashboardService.getDailyDashboardData();
  }
}
